export const formatTitlePost = (values) => `${(values.data && values.data.numberTitle) || ''} ${values.title || values.name}`.trimStart();